export const SUPPORT_PHONE_NUMBER = '217-616-2626';
